module.exports = __webpack_public_path__ + "img/inside_bouloire.ab322f8b.webp";